// import React, { useEffect, useState } from 'react';
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton,
// } from '@mui/material';
// import { Delete, Edit } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import { API_BASE_URL } from '../../config';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminFEComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedFE, setSelectedFE] = useState(null);

//   const [formData, setFormData] = useState({
//     name_of_fe: '',
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteFE, setDeleteFE] = useState(null);

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
//     { id: 'nameOfFE', field: 'nameOfFE', headerName: 'Name of the FE', width: 250 },
//     {
//       id: 'links',
//       field: 'links',
//       headerName: 'Links',
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             View Details
//           </a>
//         ) : (
//           'No File'
//         ),
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchFinancialEstablishments();
//   }, []);

//   const fetchFinancialEstablishments = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/fe/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           nameOfFE: item.name_of_fe,
//           links: item.link || '',
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch Financial Establishments data:', error);
//         setSnackbarMessage('Failed to load Financial Establishments data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddFE = () => {
//     setIsEditMode(false);
//     setFormData({ name_of_fe: '' });
//     setSelectedFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (fe) => {
//     setIsEditMode(true);
//     setSelectedFE(fe);
//     setFormData({
//       name_of_fe: fe.nameOfFE,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (fe) => {
//     setDeleteFE(fe);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/fe/${deleteFE.id}/`)
//       .then(() => {
//         setSnackbarMessage('Financial Establishment deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchFinancialEstablishments();
//       })
//       .catch((error) => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete Financial Establishment.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteFE(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.name_of_fe?.trim()) errors.name_of_fe = 'Name of FE is required';
//     if (!selectedFile && !isEditMode) errors.file = 'File is required';
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors((prev) => ({ ...prev, file: 'File size must be less than 2MB' }));
//       setSelectedFile(null);
//     } else {
//       setFormErrors((prev) => ({ ...prev, file: null }));
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append('name_of_fe', formData.name_of_fe);
//     if (selectedFile) {
//       form.append('link', selectedFile); // backend expects uploaded file under 'link'
//     }

//     if (isEditMode) {
//       api
//         .patch(`${API_BASE_URL}/home-notification/fe/${selectedFE.id}/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         })
//         .then(() => {
//           setSnackbarMessage('Financial Establishment updated successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchFinancialEstablishments();
//         })
//         .catch((error) => {
//           console.error('Update failed:', error);
//           setSnackbarMessage('Failed to update Financial Establishment.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => setOpenFormDialog(false));
//     } else {
//       api
//         .post(`${API_BASE_URL}/home-notification/fe/`, form, {
//           headers: { 'Content-Type': 'multipart/form-data' },
//         })
//         .then(() => {
//           setSnackbarMessage('Financial Establishment added successfully.');
//           setSnackbarSeverity('success');
//           setSnackbarOpen(true);
//           fetchFinancialEstablishments();
//         })
//         .catch((error) => {
//           console.error('Add failed:', error);
//           setSnackbarMessage('Failed to add Financial Establishment.');
//           setSnackbarSeverity('error');
//           setSnackbarOpen(true);
//         })
//         .finally(() => setOpenFormDialog(false));
//     }
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box
//         display="flex"
//         justifyContent="space-between"
//         alignItems="center"
//         backgroundColor="rgba(195, 234, 203, 0.1)"
//         p={2}
//       >
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Financial Establishments
//         </Typography>
//         <Button variant="contained" color="primary" onClick={handleAddFE}>
//           Add Financial Establishment
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? 'Edit Financial Establishment' : 'Add Financial Establishment'}</DialogTitle>
//         <DialogContent>
//           <TextField
//             margin="dense"
//             label="Name of the FE"
//             fullWidth
//             value={formData.name_of_fe}
//             error={!!formErrors.name_of_fe}
//             helperText={formErrors.name_of_fe}
//             onChange={(e) => setFormData({ ...formData, name_of_fe: e.target.value })}
//           />
//           <Box mt={2}>
//             <input
//               accept="*"
//               style={{ display: 'block', marginTop: '8px' }}
//               id="file-upload"
//               type="file"
//               onChange={handleFileChange}
//             />
//             {formErrors.file && (
//               <Typography variant="body2" color="error">
//                 {formErrors.file}
//               </Typography>
//             )}
//             {isEditMode && !selectedFile && selectedFE?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{' '}
//                 <a href={`${API_BASE_URL}${selectedFE.links}`} target="_blank" rel="noopener noreferrer">
//                   View Details
//                 </a>
//               </Typography>
//             )}
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)}>Cancel</Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary">
//             {isEditMode ? 'Update' : 'Add'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this Financial Establishment?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
//           <Button onClick={handleDelete} variant="contained" color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton,
  LinearProgress,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import { API_BASE_URL } from '../../config';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminFEComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedFE, setSelectedFE] = useState(null);

  const [formData, setFormData] = useState({ name_of_fe: '' });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteFE, setDeleteFE] = useState(null);

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 70 },
    { id: 'nameOfFE', field: 'nameOfFE', headerName: 'Name of the FE', width: 250 },
    {
      id: 'links',
      field: 'links',
      headerName: 'Links',
      width: 120,
      renderCell: (params) => params.value ? (
        <a href={params.value} target="_blank" rel="noopener noreferrer">View Details</a>
      ) : ('No File'),
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchFinancialEstablishments();
  }, []);

  const fetchFinancialEstablishments = () => {
    setLoading(true);
    axios.get(`${API_BASE_URL}/home-notification/fe/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          nameOfFE: item.name_of_fe,
          links: item.link || '',
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Financial Establishments data:', error);
        setSnackbarMessage('Failed to load Financial Establishments data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddFE = () => {
    setIsEditMode(false);
    setFormData({ name_of_fe: '' });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleEdit = (fe) => {
    setIsEditMode(true);
    setSelectedFE(fe);
    setFormData({ name_of_fe: fe.nameOfFE });
    setSelectedFile(null);
    setFormErrors({});
    setUploadProgress(0);
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (fe) => {
    setDeleteFE(fe);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/home-notification/fe/${deleteFE.id}/`)
      .then(() => {
        setSnackbarMessage('Financial Establishment deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchFinancialEstablishments();
      })
      .catch((error) => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete Financial Establishment.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteFE(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name_of_fe?.trim()) errors.name_of_fe = 'Name of FE is required';
    if (!selectedFile && !isEditMode) errors.file = 'File is required';
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = 'File size must be less than 2MB';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors(prev => ({ ...prev, file: 'File size must be less than 2MB' }));
      setSelectedFile(null);
    } else {
      setFormErrors(prev => ({ ...prev, file: null }));
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append('name_of_fe', formData.name_of_fe);
    if (selectedFile) form.append('link', selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(`/home-notification/fe/${selectedFE.id}/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Financial Establishment updated successfully.');
      } else {
        await api.post(`/home-notification/fe/`, form, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage('Financial Establishment added successfully.');
      }

      setSnackbarSeverity('success');
      setSnackbarOpen(true);
      fetchFinancialEstablishments();
      setOpenFormDialog(false);
    } catch (error) {
      console.error('Submit failed:', error);
      setSnackbarMessage('Failed to submit Financial Establishment.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195, 234, 203, 0.1)" p={2}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Financial Establishments
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddFE} disabled={uploading}>
          Add Financial Establishment
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{ '& .MuiDataGrid-columnHeaders': { backgroundColor: '#1976d2', color: '#fff', fontWeight: 'bold' } }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? 'Edit Financial Establishment' : 'Add Financial Establishment'}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Name of the FE"
            fullWidth
            value={formData.name_of_fe}
            error={!!formErrors.name_of_fe}
            helperText={formErrors.name_of_fe}
            onChange={(e) => setFormData({ ...formData, name_of_fe: e.target.value })}
            disabled={uploading}
          />
          <Box mt={2}>
            <input
              accept="*"
              style={{ display: 'block', marginTop: '8px' }}
              id="file-upload"
              type="file"
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedFE?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{' '}
                <a href={`${API_BASE_URL}${selectedFE.links}`} target="_blank" rel="noopener noreferrer">
                  View Details
                </a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={uploading}>
            {uploading ? <LoadingSpinner size={20} /> : isEditMode ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this Financial Establishment?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="contained" color="error" disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
    </Box>
  );
};
